export default __webpack_public_path__ + "static/media/priority.298644a2.png";